var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-stepper-content",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.paso.visible,
          expression: "paso.visible"
        }
      ],
      attrs: { step: _vm.paso.step }
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }